var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79998 0H19.2C19.8628 0 20.4 0.537188 20.4 1.2V22.8C20.4 23.4628 19.8628 24 19.2 24H4.79998C4.13716 24 3.59998 23.4628 3.59998 22.8V1.2C3.59998 0.537188 4.13716 0 4.79998 0ZM16.8 2.40002H7.2C6.53719 2.40002 6 2.93721 6 3.60002V8.40002C6 9.06284 6.53719 9.60003 7.2 9.60003H16.8C17.4628 9.60003 18 9.06284 18 8.40002V3.60002C18 2.93721 17.4628 2.40002 16.8 2.40002ZM9.60001 12H7.20001V13.2H9.60001V12ZM10.8 12H13.2V13.2H10.8V12ZM16.8 12H14.4V13.2H16.8V12ZM7.20001 15.6H9.60001V16.8H7.20001V15.6ZM13.2 15.6H10.8V16.8H13.2V15.6ZM14.4 15.6H16.8V16.8H14.4V15.6ZM9.60001 19.2H7.20001V20.4H9.60001V19.2ZM10.8 19.2H13.2V20.4H10.8V19.2ZM16.8 19.2H14.4V20.4H16.8V19.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.bfa3a2b5bd8c5b4e2f2b61996290431d.svg";
export { ForwardRef as ReactComponent };